import Route from "../../../router/Route";
import Overview from "../pages/Overview.vue";
import ScenariosOverview from "../pages/ScenariosOverview.vue";
import TodosOverview from "../pages/TodosOverview.vue";
import LabelsOverview from "../pages/LabelsOverview.vue";
import DashboardOverview from "../pages/DashboardOverview.vue";
import ScenarioBuilder from "../pages/ScenarioBuilder.vue";

export default new Route(
	"pro_loyalty",
	"/pro-loyalty",
	Overview,
	[
		new Route("pro_loyalty.dashboard", "dashboard", DashboardOverview, []),
		new Route("pro_loyalty.scenarios", "scenarios", ScenariosOverview, [
			new Route(
				"pro_loyalty.scenarios.builder",
				":model_uuid/:version_uuid",
				ScenarioBuilder,
				[]
			),
		]),
		new Route("pro_loyalty.todos", "todos", TodosOverview, []),
		new Route("pro_loyalty.labels", "labels", LabelsOverview, []),
	],
	{},
	(): string => {
		return `/pro-loyalty/dashboard`;
	}
);
